import type { z } from 'zod';

import { NonEmptyText } from './non-empty-text';

export const County = NonEmptyText;

export type County = z.infer<typeof County>;
